import axios, { AxiosRequestConfig } from "axios";

export default async function getHasuraToken(accessToken: string, signal?: AbortSignal): Promise<string> {
  const config: AxiosRequestConfig = {
    baseURL: import.meta.env.VITE_CARBON0_BASEURL,
    headers: { Authorization: `Bearer ${accessToken}` },
    signal,
  };

  const response = await axios.get<string>("api/hasura/token", config);

  return response.data;
}
